{
  "display_name": "Andre",
  "download_url": "https://dev.hearthfire.ai/api/monthly-summary/2026-04.pdf",
  "household_name": "Andre's household",
  "period": "April 2026"
}
